export const readReceiptCopy = {
  header: '',
  description: '',
  descriptionInfo: '',
  confirmBtnText: '',
  successToast: '',
  noText: '',
  noSubject: '',
};
